import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getExchangeRates = unaryRpc({
  name: "getExchangeRates",
  input: z.null(),
  output: z.record(z.string(), z.number()),
});
